import React from "react";

export default function stepOne(props) {
  const { nextStep, befStep } = props;
  let next = (e) => {
    e.preventDefault();
    nextStep();
  };
  let before = (e) => {
    e.preventDefault();
    befStep();
  };
  return (
    <div>
      Step One
      <button
        onClick={(e) => {
          before(e);
        }}
      >
        before
      </button>
      <button
        onClick={(e) => {
          next(e);
        }}
      >
        next
      </button>
    </div>
  );
}
